// Host URL hash'i -> kabuk yonlendirme yuku; loader ve testler paylasir (CJS)
const TABS = ["home", "messages", "help"];
function isShellTab(x) { return TABS.indexOf(x) !== -1; }
function decode(s) { try { return decodeURIComponent(s); } catch (e) { return s; } }
function parseSupsisHash(hash) {
    const h = String(hash || "").replace(/^#/, "");
    if (h.indexOf("supsis-") !== 0) return null;
    const rest = h.slice(7);
    if (isShellTab(rest)) return { tab: rest };
    if (rest.indexOf("article-") === 0 && rest.length > 8) return { tab: "help", article: decode(rest.slice(8)) };
    if (rest.indexOf("search-") === 0 && rest.length > 7) return { tab: "help", query: decode(rest.slice(7)) };
    return null;
}
module.exports = { parseSupsisHash, isShellTab, TABS };



//////////////////
// WEBPACK FOOTER
// ./static/src/shellLinks.js
// module id = y0aA
// module chunks = 1 2